import HomePage from './MainPage';

export default HomePage;
